/**
 * 주어진 문자열이 숫자인지 확인
 * @param {string} str - 확인할 문자열
 * @returns {boolean} 주어진 문자열이 숫자인 경우 true, 그렇지 않으면 false를 반환
 */
export const isNumeric = (str: string): boolean => {
  return !isNaN(parseFloat(str.replaceAll(',', '')));
};
